import { GetterTree } from 'vuex';
import { CartState, RootState } from '../types';

export const getters: GetterTree<CartState, RootState> = {
    cartCount: (state) => (type: string) => state.count,
};
